// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"730":"4a1f0c02","828":"5a1f503c"}[chunkId] + ".chunk.css";
};